export default "__VITE_ASSET__CmAA9MIN__"